import React from "react";
import { styled } from "@mui/material/styles";
import delivery from "../../../assets/images/delivery.png";
import { Link } from "react-router-dom";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import MainButton from "../../shared/Button";
import GoogleMap from "../../shared/map";
import { useNavigate } from "react-router-dom";

// import GoogleMapReact from "google-map-react";

const DeliveryHomeMain = styled("div")(({ theme }) => ({
  height: "100vh",
  minHeight: "100vh",
  width: "100%",
  position: "relative",
  zIndex: 3,
}));

const PackageDeliveryBox = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "40px",
  left: "10%",
  transform: "translateX(-10%)",
  width: "70%",
  maxWidth: "450px",
  zIndex: 1,
  backgroundColor: "#fff",
  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
  padding: "40px",
  marginBottom: "130px",
  "& .Box_section": {
    border: "1px solid rgba(11, 11, 11, 0.2)",
    padding: "0 8px",
    borderRadius: "12px",
    "& img": { width: "100%", height: "auto" },
    "& h6": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "18px",
      lineHeight: "25px",
      color: theme.palette.colors.BlackBean,
      fontFamily: theme.typography.fontFamily,
      padding: "10px 0 0px 7px",
    },
    "& p": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "22px",
      color: "rgba(11, 11, 11, 0.75)",
      fontFamily: theme.typography.fontFamily,
      padding: "0 0 7px 7px",
    },
    "& a": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "16px",
      lineHeight: "22px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
      paddingLeft: "7px",
      display: "flex",
      textDecoration: "none",
      width: "50%",
      alignItems: "center",
      margin: "10px 0",
      gap: "5px",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    maxWidth: "100%",
    top: "inherit",
    bottom: 0,
    boxShadow: "0px -1px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "20px 20px 0px 0px",
    marginBottom: "0px",
    "& .Box_section": {
      display: "none",
    },
    padding: "20px",
  },
}));

const MainTitle = styled("h6")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "24px",
  lineHeight: "33px",
  color: theme.palette.colors.BlackBean,
  fontFamily: theme.typography.fontFamily,
  marginBottom: "25px",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
}));
const MobileText = styled("div")(({ theme }) => ({
  "& h6": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    marginBottom: "5px",
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "rgba(11, 11, 11, 0.75)",
  },
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
  [theme.breakpoints.between("md", "lg")]: {
    display: "none",
  },
}));

const DeliveryHome = () => {
  const navigate = useNavigate();

  return (
    <DeliveryHomeMain clasName="DeliveryMain">
      <GoogleMap LocationIcon={true} />
      <PackageDeliveryBox>
        <MainTitle>Request Now</MainTitle>
        <div className="Box_section">
          <img src={delivery} alt="delivery" />
          <h6>Deliver your packages with ease</h6>
          <p>We deliver your packages on just one tap</p>
          <Link to="/delivery-type">
            Get started <ArrowRightAltIcon />
          </Link>
        </div>
        <MobileText>
          <h6>Deliver your packages with ease</h6>
          <p>We deliver your packages on just one tap</p>
        </MobileText>
        <MainButton
          type="button"
          label="Request a Delivery"
          MT="50"
          onClick={() => navigate("/delivery-type")}
        />
      </PackageDeliveryBox>
    </DeliveryHomeMain>
  );
};

export default DeliveryHome;
